module.exports = __webpack_public_path__ + "static/media/18ECA8.87376ef3.jpg";